import SocialLinks from "./basic/Social/links";
import data from "../mock/data.json";

const Footer = () => {
  return (
    <>
      {/*======= Footer =======*/}
      {/*<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#FCA61F"
          d="m0 160 34.3 10.7C68.6 181 137 203 206 213.3 274.3 224 343 224 411 192c69-32 138-96 206-85.3 68.7 10.3 137 96.3 206 96 68.4.3 137-85.7 206-85.4 68.1-.3 137 85.7 205 112 68.9 26.7 137-5.3 172-21.3l34-16v128H0Z"
        />
      </svg>*/}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 200 1440 120">
        <path
          fill="#FCA61F"
          d="m0 320 60-26.7c60-26.3 180-80.3 300-80 120-.3 240 53.7 360 64C840 288 960 256 1080 240c120-16 240-16 300-16h60v96H0Z"
        />
      </svg>
      {/*<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#FCA61F"
          d="m0 32 60 26.7c60 26.3 180 80.3 300 128C480 235 600 277 720 245.3 840 213 960 107 1080 53.3 1200 0 1320 0 1380 0h60v320H0Z"
        />
      </svg>*/}
      {/*<svg
        width="100%"
        height="100%"
        id="svg"
        viewBox="0 0 1440 400"
        xmlns="http://www.w3.org/2000/svg"
        className="transition duration-300 ease-in-out delay-150"
      >
        <style>
          {
            '@keyframes pathAnim-0{0%,to{d:path("M 0,400 C 0,400 0,200 0,200 C 58.22564102564107,208.06923076923078 116.45128205128213,216.13846153846154 205,208 C 293.54871794871787,199.86153846153846 412.4205128205127,175.5153846153846 495,175 C 577.5794871794873,174.4846153846154 623.8666666666666,197.8 696,215 C 768.1333333333334,232.2 866.1128205128207,243.2846153846154 961,248 C 1055.8871794871793,252.7153846153846 1147.6820512820514,251.06153846153845 1227,242 C 1306.3179487179486,232.93846153846155 1373.1589743589743,216.46923076923076 1440,200 C 1440,200 1440,400 1440,400 Z")}25%{d:path("M 0,400 C 0,400 0,200 0,200 C 59.02307692307696,194.19230769230768 118.04615384615391,188.3846153846154 201,203 C 283.9538461538461,217.6153846153846 390.8384615384614,252.65384615384616 481,234 C 571.1615384615386,215.34615384615384 644.6000000000001,143 711,131 C 777.3999999999999,119 836.7615384615383,167.34615384615384 921,180 C 1005.2384615384617,192.65384615384616 1114.3538461538462,169.6153846153846 1205,167 C 1295.6461538461538,164.3846153846154 1367.8230769230768,182.19230769230768 1440,200 C 1440,200 1440,400 1440,400 Z")}50%{d:path("M 0,400 C 0,400 0,200 0,200 C 98.57948717948719,173.04358974358973 197.15897435897438,146.0871794871795 278,158 C 358.8410256410256,169.9128205128205 421.94358974358977,220.6948717948718 491,212 C 560.0564102564102,203.3051282051282 635.0666666666666,135.13333333333335 724,138 C 812.9333333333334,140.86666666666665 915.7897435897437,214.77179487179487 1004,235 C 1092.2102564102563,255.22820512820513 1165.7743589743588,221.77948717948718 1236,207 C 1306.2256410256412,192.22051282051282 1373.1128205128207,196.1102564102564 1440,200 C 1440,200 1440,400 1440,400 Z")}75%{d:path("M 0,400 C 0,400 0,200 0,200 C 88.16666666666669,169.18974358974359 176.33333333333337,138.37948717948717 260,153 C 343.66666666666663,167.62051282051283 422.83333333333326,227.67179487179482 501,250 C 579.1666666666667,272.3282051282052 656.3333333333335,256.93333333333334 745,233 C 833.6666666666665,209.06666666666666 933.8333333333333,176.5948717948718 1002,174 C 1070.1666666666667,171.4051282051282 1106.3333333333333,198.6871794871795 1174,208 C 1241.6666666666667,217.3128205128205 1340.8333333333335,208.65641025641025 1440,200 C 1440,200 1440,400 1440,400 Z")}}'
          }
        </style>
        <path
          d="M0 400V200c58.226 8.07 116.451 16.138 205 8 88.549-8.138 207.42-32.485 290-33 82.58-.515 128.867 22.8 201 40 72.133 17.2 170.113 28.285 265 33s186.682 3.062 266-6c79.318-9.062 146.159-25.53 213-42v200Z"
          strokeWidth={0}
          fill="#fca61fff"
          className="transition-all duration-300 ease-in-out delay-150"
          style={{
            animation: "pathAnim-0 4s",
            animationTimingFunction: "linear",
            animationIterationCount: "infinite",
          }}
        />
      </svg>*/}
      <footer id="footer">
        <div className="container">
          <h3>{data?.name || "Dear Roy"}</h3>
          <p>{data.summary}</p>
          <SocialLinks/>
          <div className="copyright">
            &copy; Copyright <strong><span>Portfolio</span></strong>. All Rights Reserved
          </div>
          <div className="credits">
            Designed by <a href="https://ueepinc.com/">UEEP Inc</a>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer;
